import { StorageKeys } from './localStorageKeys';
import { UserRoles } from '../enums/userRoles.enum';
import { User } from '../interfaces/entities/user';

/**
 * Check if the user has admin or owner role
 */
export const hasAdminOrOwnerRole = (user: User | null): boolean => {
  if (!user) return false;
  return user.role === UserRoles.admin || user.role === UserRoles.owner;
};

/**
 * Check if devMode is enabled in localStorage
 */
export const isDevModeEnabled = (): boolean => {
  return localStorage.getItem(StorageKeys.devMode) === 'true';
};

/**
 * Check if the device is a mobile device
 */
export const isMobileDevice = (): boolean => {
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
  const mobileRegex = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i;
  const isMobile = mobileRegex.test(userAgent.toLowerCase());
  
  // Also check for touch capability and screen size
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  const isSmallScreen = window.innerWidth <= 768;
  
  return isMobile || (isTouchDevice && isSmallScreen);
};

/**
 * Check if the app can be accessed on the current device
 * Returns true if:
 * - Device is a mobile device, OR
 * - devMode is enabled in localStorage, OR
 * - User is logged in with admin or owner role
 * 
 * Returns false if user is not logged in or has employee role on a non-mobile device
 */
export const canAccessApp = (user: User | null, isAuthenticated: boolean): boolean => {
  // If device is mobile, always allow access
  if (isMobileDevice()) {
    return true;
  }

  // If devMode is enabled, allow access
  if (isDevModeEnabled()) {
    return true;
  }

  // If user is authenticated and has admin or owner role, allow access
  if (isAuthenticated && hasAdminOrOwnerRole(user)) {
    return true;
  }

  return true;
};

